import { axios } from '@Root/API'

export const getDisability = () => {
	return axios.get(`data-disability`)
}
